import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { Row, Spinner, Button } from "reactstrap"
import API from "../../apis"
import ISGGB from "../../assets/images/ismsf.png"
import tunisie_rep from "../../assets/images/tn_rep.png"

const EmploiTemps = props => {
  const userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))

  const etudiant_id = userAuthEtudiant?.user?.id_etudiant
  const annee_id = userAuthEtudiant?.user?.annee_id

  const [loading, setLoading] = useState(true)
  const [pdfUrl, setPdfUrl] = useState(null)
  const [error, setError] = useState(null)

  const previousUrl = useRef(null)

  // Détection mobile
  const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)

  useEffect(() => {
    const loadPdf = async () => {
      setLoading(true)
      setError(null)

      try {
        const response = await API.post(
          "emploi/group/get_emploi_group_pdf",
          {
            annee_id: annee_id,
            semestre_id: props.semestre_value,
            etudiant_id: etudiant_id,
          },
          {
            responseType: "blob",
          }
        )

        // Vérifier le type retourné par l'API
        console.log("Content-Type :", response.headers?.["content-type"])
        console.log("PDF size :", response.data?.size)

        /*
        |--------------------------------------------------------------------------
        | Vérification réponse vide
        |--------------------------------------------------------------------------
        */

        if (!response.data || response.data.size === 0) {
          throw new Error("Le fichier PDF retourné est vide.")
        }

        /*
        |--------------------------------------------------------------------------
        | Création Blob PDF
        |--------------------------------------------------------------------------
        */

        const blob = new Blob([response.data], {
          type: "application/pdf",
        })

        /*
        |--------------------------------------------------------------------------
        | Supprimer ancienne URL Blob
        |--------------------------------------------------------------------------
        */

        if (previousUrl.current) {
          URL.revokeObjectURL(previousUrl.current)
        }

        /*
        |--------------------------------------------------------------------------
        | Nouvelle URL Blob
        |--------------------------------------------------------------------------
        */

        const url = URL.createObjectURL(blob)

        previousUrl.current = url
        setPdfUrl(url)
      } catch (err) {
        console.error("Erreur chargement PDF étudiant :", err)

        setError("Impossible de charger l'emploi du temps.")

        setPdfUrl(null)
      } finally {
        setLoading(false)
      }
    }

    if (etudiant_id && annee_id && props.semestre_value) {
      loadPdf()
    } else {
      setLoading(false)
    }

    return () => {
      if (previousUrl.current) {
        URL.revokeObjectURL(previousUrl.current)
        previousUrl.current = null
      }
    }
  }, [etudiant_id, annee_id, props.semestre_value])

  /*
  |--------------------------------------------------------------------------
  | Ouvrir PDF sur mobile
  |--------------------------------------------------------------------------
  */

  const openPdf = () => {
    if (!pdfUrl) return

    // Création d'un lien temporaire
    const link = document.createElement("a")

    link.href = pdfUrl
    link.target = "_blank"
    link.rel = "noopener noreferrer"

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
  }

  /*
  |--------------------------------------------------------------------------
  | Télécharger PDF
  |--------------------------------------------------------------------------
  */

  const downloadPdf = () => {
    if (!pdfUrl) return

    const link = document.createElement("a")

    link.href = pdfUrl
    link.download = `emploi_etudiant_${etudiant_id}.pdf`

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
  }

  /*
  |--------------------------------------------------------------------------
  | Chargement
  |--------------------------------------------------------------------------
  */

  if (loading) {
    return (
      <div
        style={{
          paddingTop: "50px",
          textAlign: "center",
        }}
      >
        <Spinner type="grow" color="primary" />

        <h4
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          Chargement ...
        </h4>
      </div>
    )
  }

  return (
    <React.Fragment>
      <Row>
        {/* HEADER */}

        <div className="container">
          <div
            className="row"
            style={{
              paddingTop: "30px",
            }}
          >
            {/* Français */}

            <div
              className="col"
              style={{
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              République Tunisienne
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
               {" Ministère de l'enseignement supérieur,"}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                de la Recherche Scientifique
              </div>
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  paddingTop: "10px",
                }}
              >
                Université de Sfax
              </div>
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                Institut Supérieur de Musique de Sfax
              </div>
            </div>

            {/* LOGO ISMSF */}

            <div
              className="col"
              style={{
                textAlign: "center",
              }}
            >
              <img
                alt="ISMSF"
                src={ISGGB}
                style={{
                  width: "70%",
                  maxWidth: "120px",
                }}
              />
            </div>

            {/* LOGO TUNISIE */}

            <div
              className="col"
              style={{
                textAlign: "center",
              }}
            >
              <img
                alt="Tunisie"
                src={tunisie_rep}
                style={{
                  width: "28%",
                  maxWidth: "70px",
                }}
              />
            </div>

            {/* ARABE */}

            <div
              className="col"
              style={{
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              الجمهورية التونسية
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                وزارة التعليم العالي والبحث العلمي
              </div>
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  paddingTop: "10px",
                }}
              >
                جامعة ﺻﻔﺎﻗﺲ
              </div>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                اﻟﻤﻌﻬﺪ اﻟﻌﺎﻟﻲ ﻟﻠﻤﻮﺳﻴﻘﻰ ﺑﺼﻔﺎﻗﺲ
              </div>
            </div>
          </div>

          <hr
            style={{
              width: "100%",
              marginTop: "2px",
              color: "black",
            }}
          />
        </div>

        {/* PDF */}

        <div
          style={{
            width: "100%",
            padding: "0 15px",
          }}
        >
          {error ? (
            <div
              style={{
                textAlign: "center",
                padding: "30px",
                color: "red",
              }}
            >
              {error}
            </div>
          ) : pdfUrl ? (
            <>
              {/* MOBILE */}

              {isMobile ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "30px 10px",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "20px",
                      fontSize: "16px",
                    }}
                  >
                    Votre emploi du temps est disponible.
                  </div>

                  <Button
                    color="primary"
                    onClick={openPdf}
                    style={{
                      width: "100%",
                      maxWidth: "350px",
                      marginBottom: "15px",
                      padding: "12px",
                    }}
                  >
                   {" Ouvrir l'emploi du temps"}
                  </Button>

                  <br />

                  <Button
                    color="secondary"
                    onClick={downloadPdf}
                    style={{
                      width: "100%",
                      maxWidth: "350px",
                      padding: "12px",
                    }}
                  >
                    Télécharger le PDF
                  </Button>
                </div>
              ) : (
                /* PC */

                <iframe
                  src={pdfUrl}
                  title="Emploi étudiant"
                  width="100%"
                  height="900px"
                  style={{
                    border: "1px solid #ddd",
                  }}
                />
              )}
            </>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "30px",
              }}
            >
              Aucun emploi disponible.
            </div>
          )}
        </div>
      </Row>
    </React.Fragment>
  )
}

export default EmploiTemps

EmploiTemps.propTypes = {
  history: PropTypes.object,

  semestre_value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  semestre_label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
